export const SpeakerInviteConfig = {
    getSpeakerInvite : "/SpeakerInvite/GetSpeakerInvite",
    postSpeakerInvite : "/SpeakerInvite/PostSpeakerInvite"
  };